import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './AvailablePublishersPreview.scss';
import TrafficNumber from './TrafficNumber';
import PublisherIcon from './PublisherIcon';
import { getPublishersByVisitors, visitorsSum } from 'lib/parsePublishers';

export default class AvailablePublishersPreview extends Component {
  static propTypes = {
    publishers: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    publishersCount: PropTypes.number,
  };

  renderIcon(publisher) {
    return <PublisherIcon publisher={publisher} key={`publisher-icon-${publisher.get('id')}`} />;
  }
  
  render() {
    const { publishers, publishersCount } = this.props;
    const publishersByVisitors = getPublishersByVisitors(publishers);

    return (
      <div className={styles.box}>
        <div className={styles.trafficBox}>
          <div className={styles.trafficText}>
            Traffic Statistics Total of <strong className={styles.trafficBig}>
              <TrafficNumber traffic={visitorsSum(publishersByVisitors)}/>
            </strong> Monthly Unique Visitors
            from <strong className={styles.trafficBig}>{publishersCount}</strong> Publishers
          </div>
        </div>
        <div className={styles.publishersList}>
          { publishersByVisitors.map((publisher) => this.renderIcon(publisher)) }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/AvailablePublishersPreview.jsx